/* eslint-disable */

export const enum AppointmentListAppointmentScheduling {
  concluded = 1,
  next = 2,
  nextButOne = 3,
  upcoming = 4,
}
